import { default as React } from 'react';
import { useAutoSaveField } from '../../Components/AutosaveForm/AutosaveField';
import { MaskedTextField } from '../../Components/MaskedTextField';
export var MedicationStrengthDisplay = function () {
    var _a, _b, _c, _d, _e;
    var medicationField = useAutoSaveField({ field: 'medication' });
    var strength = '';
    if (!!((_a = medicationField.fieldValue) === null || _a === void 0 ? void 0 : _a.strength) && !!((_c = (_b = medicationField.fieldValue) === null || _b === void 0 ? void 0 : _b.strengthUnit) === null || _c === void 0 ? void 0 : _c.name))
        strength = medicationField.fieldValue.strength + " " + ((_e = (_d = medicationField.fieldValue) === null || _d === void 0 ? void 0 : _d.strengthUnit) === null || _e === void 0 ? void 0 : _e.name);
    return (React.createElement(MaskedTextField, { readOnly: true, label: 'Unit of use', value: strength, hideWarningEmptyHelperText: true, testId: 'text-input-strength' }));
};
